<template>
    <div id="login">
      <div class="loginConbox">
       
        <div class="login-content">
         
          <div class="right-content">
           
            <div class="title">
              账号注册
            </div>
            <el-form
                :model="loginForm"
                status-icon
                label-width="0"
                class="demo-ruleForm"
              >
                <el-form-item prop="aspName">
                  <el-input
                    type="text"
                    v-if="companyName"
                    v-model="loginForm.aspName"
                    auto-complete="off"
                    placeholder="请输入公司名称"
                    clearable
                  >
                  <img slot="prefix"  src="../../assets/images/company.png">
                  </el-input>
                </el-form-item>
                <!-- <el-form-item prop="username">
                  <el-input
                    type="text"
                    v-model="loginForm.username"
                    auto-complete="off"
                    placeholder="请输入登录账号"
                    clearable
                  >
                    <img slot="prefix"  src="../../assets/images/username.png">
                  </el-input>
                </el-form-item> -->
                <el-form-item  prop="password">
                  <el-input
                    type="password"
                    v-model="loginForm.password"
                    ref="pwd"
                    @keyup.enter.native="submitForm"
                    auto-complete="off"
                    placeholder="请输入登录密码"
                    show-password
                  >
                    <img slot="prefix"  src="../../assets/images/password.png">
                  </el-input>
                </el-form-item>
                <el-form-item prop="contackMobile">
                  <el-input
                    type="text"
                    v-model="loginForm.contackMobile"
                    auto-complete="off"
                    placeholder="请输入手机号码"
                    clearable
                  >
                    <img slot="prefix"  src="../../assets/images/telephone.png">
                  </el-input>
                </el-form-item>
                <el-form-item prop="contackEmail">
                  <el-input
                    type="text"
                    v-model="loginForm.contackEmail"
                    auto-complete="off"
                    placeholder="请输入邮箱地址"
                    clearable
                  >
                    <img slot="prefix"  src="../../assets/images/email.png">
                  </el-input>
                </el-form-item>
                <el-button
                  class="login-subBtn"
                  type="primary"
                  @click="getMessage()"
                  size="mini"
                  >注册</el-button
                >
               
              </el-form>
          </div>
        </div>
        <div class="login-footer">
        <span>@2025 湖南汉森制药股份有限公司版权所有</span>
        </div>
        
      </div>
    </div>
  </template>
  <script>
  import { getQueryString } from "@/assets/common/common";
  import { encryptDes,decryptDes } from "@/utils/des";
  import Cookies from "js-cookie";
  export default {
    data() {
      return {
        smdl: true,
        checked: true,
        loginForm: {
          username: "",
          password: "",
          aspName: "",
          contackEmail:"",
          contackMobile:"",
        
        },
       
        options: [],
        companyName: false,
        _onMessage: null,
       
      };
    },
    methods: {
     
     
      // 获取安装费用折扣
      getInstallValue() {
        const url = `${this.global.MSI_MIS}/install/getInstallValue`;
        this.$axios.post(url, { data: {} }).then((res) => {
          if (res.data.code === "0000") {
            const data = res.data.data ? res.data.data / 10 : 1;
            this.$store.dispatch("setInstallValue", data);
          }
        });
      },
     
     
      submitForm(val) {
        console.log(val,'submit')
         let reMal=/^[\w\-\.]+@[a-z0-9]+(\-[a-z0-9]+)?(\.[a-z0-9]+(\-[a-z0-9]+)?)*\.[a-z]{2,4}$/i;
         let isOk=reMal.test(this.loginForm.contackEmail)
         let phone=/^[1][3,5,7,8][0-9]{9}$/
         let isPhone=phone.test(this.loginForm.contackMobile)
          if ( this.loginForm.password === "") {
          this.$message({
            showClose: true,
            message: "密码不能为空",
            type: "error",
          });
          return false;
        }
        if (this.companyName && !this.loginForm.aspName) {
          this.$message("公司名称不能为空");
          return false;
        }
        if (this.loginForm.contackMobile==="") {
          this.$message("手机号不能为空");
          return false;
        }
        if(!isPhone){
            this.$message("请输入正确的手机号");
          return false;
          }
        if (this.loginForm.contackEmail==="") {
          this.$message("邮箱不能为空");
           return false;
        }
        if(!isOk){
            this.$message("请输入正确的邮箱地址");
           return false;
         }
        
        this.$axios.post(this.global.DMZ_BASE + "/asp/registerBaseAsp",{
          data:{
            aspName:this.loginForm.aspName,
            password:this.loginForm.password,
            type:"official",
            contactMobile:this.loginForm.contackMobile,
            contactEmail:this.loginForm.contackEmail,
            systemId:80,
            systemName:"pmp"
          }})
            .then(res=>{
                if(res.data.status === 'Y'){
                  this.$message({
                      message: '注册成功',
                      type: 'success'
                    });

                }
            })
     
      },
      getMessage(val){
        console.log(val,'-------------------------------------------------------')
        if(val.origin === this.global.BASE_URL_2971){
          const methodName = val && val.data ? val.data.type : undefined;
          const methodData = val && val.data ? val.data.data : undefined;
          console.log(methodName,methodData,'mthods')
          this[methodName](methodData)
        }
      }
    },
    created() {
      let url = window.location.href;
      if (url.indexOf("47.115.12.30") === -1) {
        this.companyName = true;
      }
      window.addEventListener('message', this.getMessage)
    },
    beforeDestroy(){
      window.removeEventListener('message', this.getMessage)
    },
    mounted() {
    
    },
  };
  </script>
  <style lang="scss" scoped>
  #login {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url(../../assets/images/grey-background.jpg) no-repeat;
    background-size: 100% 100%;
    // .logo {
    //   margin-bottom: 40px;
    //   text-align: center;
    // }
    // .logo img {
    //   width: 80%;
    // }
  
  
  
    .loginConbox {
      width: 850px;
      margin: 0 auto;
  
      .logo {
        font-family: AdobeHeitiStd-Regular;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        /* color: #2361ff; */
      }
  
      .login-content {
        width: 380px;
        min-height: 330px;
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 5px 20px 0 rgba(89,82,82,.3);
        box-sizing: border-box;
        padding: 26px 30px 32px;
        transition: all .1s linear;
              border:none ;
      }
  
      .login-footer{
        position: absolute;
        width: 100%;
        bottom: 20px;
        left:0;
        line-height: 20px;
        font-size: 16px;
        color: #fff;
        text-align: center;
      }
  
      .logo-left {
        // flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;
  
        .login-logo {
          margin-top: 50px;
          text-align: center;
  
          img{
            width: 65%;
          }
        }
  
        .logo-content {
          position: absolute;
          left: 25px;
          bottom: 27px;
  
          .top {
            margin: 0;
            font-family: FZLTHK--GBK1-0;
            font-size: 26px;
            font-weight: bold;
            font-stretch: normal;
            // line-height: 1px;
            letter-spacing: 0px;
            color: #f7f9ff;
          }
  
          .bottom {
            font-family: FZLTHK--GBK1-0;
            font-size: 10px;
            font-weight: normal;
            letter-spacing: 0px;
            color: #f7f9ff;
          }
        }
      }
  
      .right-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        width: 100%;
        background-color: #fff;
        top:15%;
  
        .logo {
          text-align: center;
          
          img {
            width: 80px;
          }
        }
  
        .title {
          margin-top:10px;
          position: relative;
  /*         font-family: MicrosoftYaHei-Bold; */
          font-size: 24px;
          text-align: center;
          font-weight: 600;
          font-stretch: normal;
          letter-spacing:0px;
         color: #c7180c; // #70BAFD
        }
  
        // .title::after {
        //   content: "";
        //   position: absolute;
        //   left: 0;
        //   bottom: -9px;
        //   width: 40px;
        //   height: 2px;
        //   background-color: #2265fe;
        // }
  
        .el-form {
          margin-top: 30px;
          text-align: center;
  
          .el-input__prefix {
            top: 8px !important;
  
            img {
              width: 18px;
            }
          }
  
          .el-input__suffix .el-input__icon {
            line-height: 1 !important;
          }
  
          .el-form-item__content {
            /* border: none !important; */
            line-height: 0 !important;
          }
          
          .el-form-item {
            margin-bottom: 15px !important;
          }
  
          .login-subBtn {
            margin-top: 30px;
            height:40px;
            font-size:16px;
            border: none;
            /* box-shadow: 4px -6px 20px 1px rgba(28, 156, 255, 0.17); */
            background-color: #c7180c;
          }
          
          .operation .el-form-item__content{
            display: flex;
            align-items: center;
            justify-content: space-between;
            border:none !important;
            color:#565e66;
  
            a {
              font-family: MicrosoftYaHei;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 35px;
              letter-spacing: 0px;
              color: #565e66;
            }
  
            a:hover{
              text-decoration:none;
            }
          }
        }
  
        .el-input,
        button,
        input {
          width: 100%;
          height: 34px;
  
        }
  
        .tip {
          position: absolute;
          bottom: 12px;
          width: 100%;
          text-align: center;
          font-family: ArialMT;
          font-size: 9px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #b3cdff;
        }
      }
    }
  
  
  
  
  
    .login-subBtn:hover {
      background-color: #005ea6;
    }
    .el-input__inner:focus {
      border-bottom: 1px solid #b40005;
      border-radius:0px;
    }
    .el-select {
      width: 100%;
    }
  
    .loginBox {
      .iconcolor {
        color: #409eff;
      }
  
      .loginCon {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 990px;
        margin: auto;
  
        .el-card__header {
          border-bottom: 0px;
        }
        .title {
          font-size: 30px;
          font-weight: 600;
          color: #ffffff;
          width: 500px;
          margin-top: 0px;
          text-align: center;
  
          &:first-child {
            font-size: 30px;
            margin-top: 50px;
            // margin-bottom: 30px;
          }
        }
  
        .login-module {
          width: 380px;
          height: 380px;
          border: none;
          margin-top: 30px;
  
          .formTitlt {
            font-size: 18px;
            font-weight: 400;
  
            .titIconbox {
              float: right;
  
              .pointer {
                cursor: pointer;
              }
            }
          }
  
          .smalltxt {
            text-align: right;
  
            .a {
              text-decoration: none;
              color: #999999;
              font-size: 12px;
              margin-left: 8px;
            }
          }
        }
  
        .el-form-item__content {
          margin-left: 0px !important;
  
          .subBtn {
            width: 100%;
          }
        }
      }
  
      .el-input__inner,
      .el-button,
      .el-card,
      .el-message {
        border-radius: 5px !important;
      }
  
      .el-form-item__content .ico {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 999;
        width: 40px;
        height: 39px;
        text-align: center;
        border-right: 1px solid #ccc;
      }
  
      .ewmbox {
        width: 100%;
        height: 240px;
        margin-top: -25px;
  
        .ewm {
          width: 140px;
          height: 140px;
          margin: 20px auto;
  
          p {
            font-size: 12px;
            padding-left: 40px;
            margin: 0;
          }
        }
  
        .ewmicon {
          width: 140px;
          margin: 20px auto 0;
  
          .iconfont {
            float: left;
          }
  
          p {
            font-size: 12px;
            padding-left: 40px;
            margin: 0;
          }
        }
      }
    }
  
    /* login样式修改 */
  
    .el-card {
      margin: 120px auto 0;
      padding: 42px 42px 36px;
      border: 1px solid #eaeced;
      overflow: hidden;
    }
  
    .el-card__body {
      padding: 20px 40px;
  
      .el-form-item {
        margin-bottom: 20px;
      }
  
      .el-form-item__content {
        line-height: 35px;
      }
  
      .el-input__inner {
        height: 34px;
        line-height: 34px;
        border:0px;
      }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/login/register.vue